import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const AchievementRewardTypes = Object.freeze({
  FREEBETS: 'FREEBETS',
});
export type AchievementRewardType = ObjectValuesUnionType<typeof AchievementRewardTypes>;

export type AchievementReward = {
  rewardType: AchievementRewardType;
  rewardParams: {
    amount: number;
  } | null;
};

export const AchievementBasketConditionModes = Object.freeze({
  SIMPLE: 'SIMPLE',
  COMBINED: 'COMBINED',
  MYMATCH: 'MYMATCH',
});
export type AchievementBasketConditionMode = ObjectValuesUnionType<typeof AchievementBasketConditionModes>;

export type AchievementBasketCondition = {
  mode: AchievementBasketConditionMode;
  minCombinedBets?: number | null;
  minOddsInCombinedSelection?: number | null;
  minMyMatchLines?: number | null;
};

export const AchievementClearModes = Object.freeze({
  PLACED: 'PLACED',
  SETTLED: 'SETTLED',
});
export type AchievementClearMode = ObjectValuesUnionType<typeof AchievementClearModes>;

export const AchievementEligiblePeriods = Object.freeze({
  PREMATCH: 'PREMATCH',
  LIVE: 'LIVE',
});
export type AchievementEligiblePeriod = ObjectValuesUnionType<typeof AchievementEligiblePeriods>;

export type AchievementEligibility = {
  maxStartDate?: number;
  clearMode?: AchievementClearMode;
  minBetOdds?: number;
  minPlacedAmount?: number | null;
  nbBetsToPlace?: number | null;
  nbBetsToWin?: number | null;
  betCents?: number | null;
  eligiblePeriod?: AchievementEligiblePeriod | null;
  allowedBetTypeCategories?: Array<number>;
  allowedBetTypeIds?: Array<number>;
  allowedMatchIds?: Array<number>;
  allowedSportIds?: Array<number>;
  allowedCategoryIds?: Array<number>;
  allowedTournamentIds?: Array<number>;
  basketConditions?: Array<AchievementBasketCondition>;
};

export type AchievementId = number;

export type AchievementState = {
  achievementId: AchievementId;
  missionId: number;
  reward?: AchievementReward | null;
  description: string;
  eligibility: AchievementEligibility;
};
